import { debug } from '@/shared/lib';

import {
  DEFAULT_TRANSCRIPTOR_PREFERENCES,
  TRANSCRIPTOR_PREFERENCES_KEY,
} from '../config/constants';
import { TranscriptorPreferences } from '../config/types';

export const getStoredPreferences = (): TranscriptorPreferences => {
  try {
    const stored = localStorage.getItem(TRANSCRIPTOR_PREFERENCES_KEY);
    if (stored) {
      const parsed = JSON.parse(stored) as Partial<TranscriptorPreferences>;
      return {
        ...DEFAULT_TRANSCRIPTOR_PREFERENCES,
        ...parsed,
        templateSeriesIds: Array.isArray(parsed.templateSeriesIds)
          ? parsed.templateSeriesIds
          : [],
      };
    }
  } catch (error) {
    debug(error);
  }
  return DEFAULT_TRANSCRIPTOR_PREFERENCES;
};
